document.addEventListener(
  "DOMContentLoaded",
  () => {

    /* =========================================
       ELEMENTS
    ========================================= */

    const sliderTrack =
      document.querySelector(
        "#gumify-slider-track"
      );

    const slides =
      document.querySelectorAll(
        ".gumify-slide"
      );

    const dots =
      document.querySelectorAll(
        ".gumify-dot"
      );

    const thumbs =
      document.querySelectorAll(
        ".gumify-thumb"
      );

    const prevButton =
      document.querySelector(
        "#gumify-prev"
      );

    const nextButton =
      document.querySelector(
        "#gumify-next"
      );

    let currentSlide = 0;

   /* =========================================
   SLIDER
========================================= */

let startX = 0;

let currentTranslate = 0;

let isDragging = false;

/* UPDATE */

function updateSlider(index) {

  if (!sliderTrack) return;

  currentSlide = index;

  currentTranslate =
    -(index * 100);

  sliderTrack.style.transition =
    "transform 0.45s ease";

  sliderTrack.style.transform =
    `translateX(${currentTranslate}%)`;

  dots.forEach((dot) =>
    dot.classList.remove("active")
  );

  thumbs.forEach((thumb) =>
    thumb.classList.remove("active")
  );

  dots[index]?.classList.add(
    "active"
  );

  thumbs[index]?.classList.add(
    "active"
  );

}

/* THUMBS */

thumbs.forEach((thumb) => {

  thumb.addEventListener(
    "click",
    () => {

      updateSlider(
        parseInt(thumb.dataset.index)
      );

    }
  );

});

/* DOTS */

dots.forEach((dot) => {

  dot.addEventListener(
    "click",
    () => {

      updateSlider(
        parseInt(dot.dataset.index)
      );

    }
  );

});

/* ARROWS */

prevButton?.addEventListener(
  "click",
  () => {

    currentSlide =
      currentSlide <= 0
        ? slides.length - 1
        : currentSlide - 1;

    updateSlider(currentSlide);

  }
);

nextButton?.addEventListener(
  "click",
  () => {

    currentSlide =
      currentSlide >= slides.length - 1
        ? 0
        : currentSlide + 1;

    updateSlider(currentSlide);

  }
);

/* =========================================
   TOUCH MOBILE
========================================= */

sliderTrack?.addEventListener(
  "touchstart",
  (e) => {

    startX =
      e.touches[0].clientX;

    isDragging = true;

    sliderTrack.style.transition =
      "none";

  },
  { passive: true }
);

sliderTrack?.addEventListener(
  "touchmove",
  (e) => {

    if (!isDragging) return;

    const currentX =
      e.touches[0].clientX;

    const diff =
      currentX - startX;

    const movePercent =
      diff / window.innerWidth * 100;

    sliderTrack.style.transform =
      `translateX(calc(${currentTranslate}% + ${movePercent}%))`;

  },
  { passive: true }
);

sliderTrack?.addEventListener(
  "touchend",
  (e) => {

    if (!isDragging) return;

    isDragging = false;

    const endX =
      e.changedTouches[0].clientX;

    const diff =
      endX - startX;

    /* SWIPE LEFT */

    if (diff < -50) {

      currentSlide =
        currentSlide >= slides.length - 1
          ? 0
          : currentSlide + 1;

    }

    /* SWIPE RIGHT */

    if (diff > 50) {

      currentSlide =
        currentSlide <= 0
          ? slides.length - 1
          : currentSlide - 1;

    }

    updateSlider(currentSlide);

  }
);

updateSlider(0);

    /* =========================================
       ACCORDION
    ========================================= */

    const accordionItems =
      document.querySelectorAll(
        ".gumify-accordion-item"
      );

    accordionItems.forEach((item) => {

      const trigger =
        item.querySelector(
          ".gumify-accordion-trigger"
        );

      const content =
        item.querySelector(
          ".gumify-accordion-content"
        );

      trigger.addEventListener(
        "click",
        () => {

          const isActive =
            item.classList.contains("active");

          accordionItems.forEach((accordion) => {

            accordion.classList.remove("active");

            accordion.querySelector(
              ".gumify-accordion-content"
            ).style.maxHeight = null;

          });

          if (!isActive) {

            item.classList.add("active");

            content.style.maxHeight =
              content.scrollHeight + "px";

          }

        }
      );

    });

  }
);